import React, { useState, useEffect } from 'react';

const AndroidSmartBanner = ({
  appId = 'mobile.consulting.patrickm.cdlp', // Remplacez par le package ID de votre app Play Store
  appName = 'CDLP',
  appAuthor = 'patrickm.consulting',
  appPrice = 'GRATUIT',
  buttonText = 'Télécharger',
  //iconUrl = '/icon.png' // Lien vers le logo de votre application
  iconUrl = 'Assets/Logos croisade/logo-cdlp.png' // Lien vers le logo de votre application
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 1. Détecter si l'utilisateur est sur Android
    const isAndroid = /Android/i.test(navigator.userAgent);
    
    // 2. Vérifier si l'utilisateur a déjà fermé la bannière précédemment
    const isDismissed = localStorage.getItem('android-banner-dismissed');

    if (isAndroid && !isDismissed) {
    //if (true) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // Masquer la bannière pendant 7 jours
    localStorage.setItem('android-banner-dismissed', 'true');
  };

  if (!isVisible) return null;

  const playStoreUrl = `market://details?id=${appId}`;
  const fallbackUrl = `https://play.google.com/store/apps/details?id=${appId}`;

  return (
    <div style={styles.banner}>
      {/* Bouton de fermeture */}
      <button onClick={handleClose} style={styles.closeButton} aria-label="Fermer">
        ✕
      </button>

      {/* Icône de l'application */}
      <img src={iconUrl} alt={appName} style={styles.icon} />

      {/* Détails de l'application */}
      <div style={styles.info}>
        <div style={styles.title}>{appName}</div>
        <div style={styles.author}>{appAuthor}</div>
        <div style={styles.price}>{appPrice} - Sur le Play Store</div>
      </div>

      {/* Bouton vers le Play Store */}
      <a 
        href={playStoreUrl} 
        onClick={(e) => {
          // Si le lien deep link `market://` échoue, redirection vers l'URL web
          setTimeout(() => { window.location.href = fallbackUrl; }, 500);
        }}
        style={styles.button}
      >
        {buttonText}
      </a>
    </div>
  );
};

// Styles CSS inline pour faciliter l'intégration
const styles = {
  banner: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '70px',
    backgroundColor: '#f4f4f4',
    borderBottom: '1px solid #ccc',
    display: 'flex',
    alignItems: 'center',
    padding: '0 10px',
    zIndex: 9999,
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '18px',
    color: '#888',
    cursor: 'pointer',
    padding: '5px 10px',
    marginRight: '5px'
  },
  icon: {
    width: '48px',
    height: '48px',
    borderRadius: '10px',
    marginRight: '12px',
    objectFit: 'cover'
  },
  info: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  title: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#333'
  },
  author: {
    fontSize: '12px',
    color: '#666'
  },
  price: {
    fontSize: '10px',
    color: '#888'
  },
  button: {
    backgroundColor: '#0F9D58', // Vert Google Play Store
    color: '#fff',
    padding: '8px 16px',
    borderRadius: '4px',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '12px',
    letterSpacing: '0.5px'
  }
};

export default AndroidSmartBanner;